import { render } from "./ForgotPasswordOTPView.vue?vue&type=template&id=43aa6e2a"
import script from "./ForgotPasswordOTPView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordOTPView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__